<template>
  <div class="fixed props-group">
    <el-form-item label="设置选项"></el-form-item>
    <div class="fixed-option">
      <div class="static">
        <el-form-item label="固定选项">
          <el-switch v-model="component.properties.template.enable"></el-switch>
        </el-form-item>
        <template v-if="component.properties.template && component.properties.template.enable">
          <el-form-item label="选项" prop="properties.template.stringOptions" :rules="{required: true, message: '请输入选项', trigger: 'blur'}">
            <el-input type="textarea"
                      rows="5"
                      v-model="component.properties.template.stringOptions">
            </el-input>
          </el-form-item>
        </template>
      </div>

      <div class="dataSource">
        <el-form-item label="关联数据源">
          <el-switch v-model="component.properties.dataSource.enable"></el-switch>
        </el-form-item>
        <el-form-item label="归档文本" v-if="component.properties.dataSource && component.properties.dataSource.enable && component.componentType === 'rc-combobox'">
          <el-select v-model="component.properties.archived.showColumnId" filterable>
            <el-option v-if="showCurrentOption" label="[当前控件]" :value="component.properties.archived.showColumnId" />
            <el-option v-for="item in columnOptions" :key="item.id" :label="item | formatNew" :value="item.id" />
          </el-select>
        </el-form-item>
        <template v-if="component.properties.dataSource && component.properties.dataSource.enable">
          <el-form-item label="辅助表" prop="properties.dataSource.reportId" :rules="{ required: true, message: '请选择来源', trigger: 'change' }">
            <public-combobox
              v-model="component.properties.dataSource.reportId"
              :options="dataSourceReports"
              @change="changeDataSource">
            </public-combobox>
          </el-form-item>

          <el-form-item label="选项ID" prop="properties.dataSource.columnId" :rules="{ required: true, message: '请选择选项ID', trigger: 'change' }">
            <public-combobox v-model="component.properties.dataSource.columnId" :options="columns"></public-combobox>
          </el-form-item>

          <el-form-item label="选项文本" prop="properties.dataSource.showColumnId" :rules="{ required: true, message: '请选择选项文本', trigger: 'change' }">
            <public-combobox v-model="component.properties.dataSource.showColumnId" :options="columns"></public-combobox>
          </el-form-item>

          <el-form-item v-for="filter in filters" :label="filter.name" :key='filter.columnId'>
            <div class="formula" v-html="expressionShow(filter.defaultValue)" @click="focus(filter)"></div>
          </el-form-item>

          <template v-if="component.properties.dataSource.bindData">
            <el-form-item label="数据绑定">
              <el-switch v-model="component.properties.dataSource.bindData.enable"></el-switch>
            </el-form-item>
          </template>
          <div class="binding-data" v-if="component.properties.dataSource.bindData && component.properties.dataSource.bindData.enable">
            <template v-for="(dataSource, index) in component.properties.dataSource.bindData.dataBinding">
              <div class="binding-detail" :key="index">
                <div class="title">
                  添加绑定
                  <i class="el-icon-close" @click="remove(index)"></i>
                </div>
                <el-form-item class="content" label="选择字段">
                  <el-select v-model="dataSource.showColumnId" placeholder="请选择" filterable clearable>
                    <el-option
                      v-for="item in columns"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="content" label="选择控件">
                  <el-select v-model="dataSource.componentId" placeholder="请选择" filterable clearable>
                    <el-option
                      v-for="item in getComponentName"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                      :disabled="item.disabled">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </template>
            <div class="add-binding" @click="addBinding">+ 添加绑定</div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { calculateMixin } from '../components/mixins'
import publicCombobox from '@/components/public/public-combobox.vue'

export default {
  name: 'attr-fixed-option',
  props: ['component'],
  inject: ['formService'],
  mixins: [calculateMixin],
  components: {publicCombobox},
  data () {
    return {
      filters: [],
      columns: [],
      options: []
    }
  },
  mounted () {
    if (this.component.properties.template.enable) {
      this.loadTemplateOption()
    } else if (this.component.properties.dataSource.enable) {
      this.loadDataSourceOption()
    }
    this.component.properties.dataSource.reportId && this.loadTableColumns(this.component.properties.dataSource.reportId)
  },
  watch: {
    'component.properties.dataSource': {
      handler (val) {
        if (val.enable && val.reportId && val.showColumnId && val.columnId) {
          this.loadTableColumns(val.reportId)
          this.loadDataSourceOption()
        } else {
          this.options = []
          this.$emit('setOption', this.options)
        }
        this.component.properties.template.enable = !val.enable
      },
      deep: true
    },
    'component.properties.template.enable' (val) {
      if (val) {
        this.loadTemplateOption()
        this.component.properties.dataSource = {
          enable: false,
          dataSource: '',
          reportId: '',
          columnId: '',
          showColumnId: '',
          // 数据绑定
          bindData: {
            enable: false,
            dataBinding: [{showColumnId: '', componentId: ''}]
          }
        }
      } else {
        this.component.properties.dataSource.enable = true
      }
    },
    'component.properties.template.stringOptions' (val) {
      this.loadTemplateOption()
    },
    'component.archive.columnId' (val) {
      // 监听归档变化
      let column = this.columnOptions.find(m => m.id === val)
      if (column) {
        let showColumn = this.columnOptions.find(m => `${m.name}ID` === `${column.name}`)
        if (showColumn) {
          this.component.properties.archived.showColumnId = showColumn.id
        }
      }
    }
  },
  methods: {
    changeDataSource (val) {
      this.component.properties.dataSource.columnId = ''
      this.component.properties.dataSource.showColumnId = ''
      this.component.properties.dataSource.bindData.dataBinding = [{showColumnId: '', componentId: ''}]
      this.loadTableColumns(val)
    },
    loadTableColumns (val) {
      this.filters = []
      this.columns = []
      let dataSourceReport = {}
      if (val) {
        this.formService.loadDataReport(val).then(() => {
          dataSourceReport = this.formService.options.dataSourceReports.find(m => m.id === val)
          // 只取出需要的字段
          dataSourceReport.filters.forEach(m => {
            if (m.filterType !== 'senior') {
              if (this.component.properties.dataSource.filter) {
                m.defaultValue = this.component.properties.dataSource.filter[m.id]
              }
              this.filters.push(_.pick(m, ['id', 'name', 'columnId', 'defaultValue']))
            }
          })
          dataSourceReport.columns.forEach(n => {
            this.columns.push(_.pick(n, ['name', 'id', 'pinyinName', 'pinyinFirstChar']))
          })
        })
      }
    },
    focus (filter) {
      // 改弹窗参照 element this.$message 改造而来, 涉及 ui 方面的可直接参考 element 进行修改
      this.$Popup.calculation({
        parameter: {
          expression: filter.defaultValue,
          dataSource: this.getDataSource,
          currentColumnId: this.component.archive.columnId,
          dataSourceEnable: true,
          dataSourceReports: this.formService.options.dataSourceReports
        },
        width: '1000px'
      }).then((data) => {
        // action 两种 confirm 表示点击的是确认, cancel 表示取消
        if (data.action === 'confirm') {
          this.getExpression(data.value, filter)
          filter.defaultValue = data.value
        }
      })
    },
    getExpression (expression, filter) {
      if (!this.component.properties.dataSource.filter) {
        this.component.properties.dataSource.filter = {}
      }
      this.component.properties.dataSource.filter[filter.id] = expression
    },
    expressionShow (defaultValue) {
      if (defaultValue) {
        return this.expressionToWithCode(defaultValue)
      }
    },
    loadTemplateOption () {
      this.options = []
      this.component.properties.template.stringOptions.trim().split('\n').forEach(m => {
        this.options.push({id: m, value: m})
      })
      this.$emit('setOption', this.options)
    },
    loadDataSourceOption () {
      let dataSource = this.component.properties.dataSource
      this.options = []
      // 设置页面只取出最近的三十条数据
      let params = {'index': 1, 'size': 20, filters: {}}
      dataSource.filter && Object.keys(dataSource.filter).forEach(m => {
        if (!dataSource.filter[m].match(/\$\{(.*?)\}/)) {
          params.filters[m] = dataSource.filter[m]
        }
      })
      this.$axios.get(`/report-api/report/data/${dataSource.reportId}`, {params: params}).then((res) => {
        res.data.forEach(m => {
          this.options.push({id: m[dataSource.columnId], value: m[dataSource.showColumnId]})
        })
      })
      this.$emit('setOption', this.options)
    },
    remove (index) {
      this.component.properties.dataSource.bindData.dataBinding.splice(index, 1)
    },
    addBinding () {
      if (this.component.properties.dataSource.bindData.enable) {
        this.component.properties.dataSource.bindData.dataBinding.push({'showColumnId': '', 'componentId': ''})
      }
    }
  },
  filters: {
    formatNew: (item) => item.isNew ? `${item.name}*` : item.name
  },
  computed: {
    dataSourceReports () {
      return this.formService.options.dataSourceReports
    },
    columnOptions () {
      return this.formService.getColumns(this.component.archive.tableId)
    },
    showCurrentOption () {
      let columnOptions = this.columnOptions
      return columnOptions && !columnOptions.some(m => m.id === this.component.properties.archived.showColumnId)
    },
    getComponentName () {
      let table = this.$_.cloneDeep(this.formService.schema.tables.find(m => m.tableId === this.component.archive.tableId))
      if (table && table.columns) {
        let componentIds = []
        this.component.properties.dataSource.bindData.dataBinding.forEach(m => {
          componentIds.push(m.componentId)
        })
        table.columns.forEach(m => {
          m.disabled = !componentIds.indexOf(m.id)
        })
        return table.columns
      }
    }
  }
}
</script>

<style lang="scss">
  .fixed {
    border-top: 1px solid #c2c3c4;
    margin: 0 -30px;
    padding: 0 13px 0 20px;

    & > .el-form-item {
      padding-left: 10px;
    }

    .fixed-option {
      border: 1px solid #EBEBEB;
      padding-left: 10px;
      padding-right: 10px;
      margin-bottom: 14px;

      .dataSource {
        border-top: 1px solid #EBEBEB;

        .formula {
          position: absolute;
          margin-top: -14px;
          padding: 0 10px;
          top: 50%;
          outline: none;
          border: 1px solid #e4e7ed;
          background: #fff;
          border-radius: 4px;
          max-height: 80px;
          overflow: hidden;
          width: 100%;
          height: 28px;
          line-height: 28px;

          code {
            padding: 2px 4px;
            font-size: 90%;
            color: #c7254e;
            background-color: #f9f2f4;
            border-radius: 4px;
          }
        }

        .binding-detail {
          border: 1px solid #C2C3C4;
          border-radius: 4px;
          width: calc(100% + 20px);
          margin-left: -10px;
          margin-bottom: 14px;
          .title {
            margin-left: 10px;
            margin-right: 10px;
            font-size: 12px;
            color: #606266;
            border-bottom: 1px solid #C2C3C4;
            height: 30px;
            line-height: 30px;
            .el-icon-close {
              display: none;
              color: #FA4B4B;
              cursor: pointer;
              float: right;
              padding-top: 10px;
            }
          }
          .content {
            padding-left: 10px;
            padding-right: 10px;
          }
          &:hover {
            border: 1px solid #ADDAFE;
            .el-icon-close {
              display: inline;
            }
          }
        }
        .add-binding {
          text-align: center;
          font-size: 12px;
          color: #54ABF1;
          cursor: pointer;
        }
        .binding-data {
          .binding-detail {
            width: 100%;
            margin: 0;
            border-color: #EBEBEB;
            .title {
              border-color: #EBEBEB;
              color: #C2C3C4;
            }
          }
          .add-binding {
            padding: 10px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/componentAttr/setting-option.vue